import React, { Fragment } from 'react';
import { useDropzone } from 'react-dropzone';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import { empty, emptyOrZero, showNotification } from './../../../utils';

const UthApparelUnisexForm = React.memo((props) => {
    const {
        // acceptedFiles,
        // fileRejections,
        getRootProps,
        getInputProps
    } = useDropzone({
        multiple: true,
        onDrop: (files) => {
            for (let i = 0; i < files.length; i++) {
                props.addFile(files[i]);
            }
        }
    });

    if (props.apparelItem == null) {
        return null;
    }

    const handleSetField = (field, event) => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        let count = 0;
        if (parseInt(props.variables.uth_unisex_ink_university_orange)) {
            count++;
        }
        if (parseInt(props.variables.uth_unisex_ink_university_blue)) {
            count++;
        }
        if (parseInt(props.variables.uth_unisex_ink_university_grey)) {
            count++;
        }
        if (parseInt(props.variables.uth_unisex_ink_university_black_white)) {
            count++;
        }
        if (parseInt(props.variables.uth_unisex_ink_gulf_blue)) {
            count++;
        }
        if (parseInt(props.variables.uth_unisex_ink_mustard)) {
            count++;
        }
        if (parseInt(props.variables.uth_unisex_ink_dark_sage)) {
            count++;
        }
        if (parseInt(props.variables.uth_unisex_ink_dusty_lavender)) {
            count++;
        }

        if (field === 'uth_unisex_ink_university_orange' && value && count >= 4) {
            return showNotification('You cannot choose more than 4 colors', 'The maximum colors is 4', 'info');
        }
        if (field === 'uth_unisex_ink_university_blue' && value && count >= 4) {
            return showNotification('You cannot choose more than 4 colors', 'The maximum colors is 4', 'info');
        }
        if (field === 'uth_unisex_ink_university_grey' && value && count >= 4) {
            return showNotification('You cannot choose more than 4 colors', 'The maximum colors is 4', 'info');
        }
        if (field === 'uth_unisex_ink_university_black_white' && value && count >= 4) {
            return showNotification('You cannot choose more than 4 colors', 'The maximum colors is 4', 'info');
        }
        if (field === 'uth_unisex_ink_gulf_blue' && value && count >= 4) {
            return showNotification('You cannot choose more than 4 colors', 'The maximum colors is 4', 'info');
        }
        if (field === 'uth_unisex_ink_mustard' && value && count >= 4) {
            return showNotification('You cannot choose more than 4 colors', 'The maximum colors is 4', 'info');
        }
        if (field === 'uth_unisex_ink_dark_sage' && value && count >= 4) {
            return showNotification('You cannot choose more than 4 colors', 'The maximum colors is 4', 'info');
        }
        if (field === 'uth_unisex_ink_dusty_lavender' && value && count >= 4) {
            return showNotification('You cannot choose more than 4 colors', 'The maximum colors is 4', 'info');
        }

        props.setField(field, value);
    };

    const continueHandler = (type = 1) => {
        if (
            emptyOrZero(props.variables.uth_unisex_position_full_front) &&
            emptyOrZero(props.variables.uth_unisex_position_full_back) &&
            emptyOrZero(props.variables.uth_unisex_position_left_chest) &&
            emptyOrZero(props.variables.uth_unisex_position_right_chest) &&
            emptyOrZero(props.variables.uth_unisex_position_sleeve) &&
            emptyOrZero(props.variables.uth_unisex_position_other)
        ) {
            return showNotification('Complete Information', 'Select at least one Image Position', 'info');
        }

        if (!emptyOrZero(props.variables.uth_unisex_position_other) && empty(props.variables.uth_unisex_position_other_text)) {
            return showNotification('Complete Information', 'Enter the Other Area Position', 'info');
        }

        if (empty(props.variables.uth_unisex_shirt_color)) {
            return showNotification('Complete Information', 'Select the Shirt Color', 'info');
        }

        if (
            emptyOrZero(props.variables.uth_unisex_size_small) &&
            emptyOrZero(props.variables.uth_unisex_size_medium) &&
            emptyOrZero(props.variables.uth_unisex_size_large) &&
            emptyOrZero(props.variables.uth_unisex_size_xl) &&
            emptyOrZero(props.variables.uth_unisex_size_2xl) &&
            emptyOrZero(props.variables.uth_unisex_size_3xl)
        ) {
            return showNotification('Complete Information', 'Select at least one size', 'info');
        }

        if (!emptyOrZero(props.variables.uth_unisex_size_small) && empty(props.variables.uth_unisex_size_small_qty)) {
            return showNotification('Complete Information', 'Enter the quantity for the Small size', 'info');
        }
        if (!emptyOrZero(props.variables.uth_unisex_size_medium) && empty(props.variables.uth_unisex_size_medium_qty)) {
            return showNotification('Complete Information', 'Enter the quantity for the Medium size', 'info');
        }
        if (!emptyOrZero(props.variables.uth_unisex_size_large) && empty(props.variables.uth_unisex_size_large_qty)) {
            return showNotification('Complete Information', 'Enter the quantity for the Large size', 'info');
        }
        if (!emptyOrZero(props.variables.uth_unisex_size_xl) && empty(props.variables.uth_unisex_size_xl_qty)) {
            return showNotification('Complete Information', 'Enter the quantity for the X-Large size', 'info');
        }
        if (!emptyOrZero(props.variables.uth_unisex_size_2xl) && empty(props.variables.uth_unisex_size_2xl_qty)) {
            return showNotification('Complete Information', 'Enter the quantity for the 2XL size', 'info');
        }
        if (!emptyOrZero(props.variables.uth_unisex_size_3xl) && empty(props.variables.uth_unisex_size_3xl_qty)) {
            return showNotification('Complete Information', 'Enter the quantity for the 3XL size', 'info');
        }

        let count = 0;
        if (!empty(props.variables.uth_unisex_size_small_qty)) {
            count += parseInt(props.variables.uth_unisex_size_small_qty);
        }
        if (!empty(props.variables.uth_unisex_size_medium_qty)) {
            count += parseInt(props.variables.uth_unisex_size_medium_qty);
        }
        if (!empty(props.variables.uth_unisex_size_large_qty)) {
            count += parseInt(props.variables.uth_unisex_size_large_qty);
        }
        if (!empty(props.variables.uth_unisex_size_xl_qty)) {
            count += parseInt(props.variables.uth_unisex_size_xl_qty);
        }
        if (!empty(props.variables.uth_unisex_size_2xl_qty)) {
            count += parseInt(props.variables.uth_unisex_size_2xl_qty);
        }
        if (!empty(props.variables.uth_unisex_size_3xl_qty)) {
            count += parseInt(props.variables.uth_unisex_size_3xl_qty);
        }
        if (count < 15) {
            return showNotification('Complete Order', 'The minimum order is 15', 'info');
        }

        if (props.cxmlData.buyer_cookie == null) {
            props.addToCart(1, props.history, type);
        } else {
            props.addToCart(2, props.history, type);
        }
    };

    let buttonLabel = 'Checkout';
    if (props.addingToCart) {
        buttonLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Adding to Cart...</Fragment>;
    }

    let saveWorkLabel = 'Save Work';
    if (props.savingWork) {
        saveWorkLabel = <Fragment><i className="fas fa-circle-notch fa-spin" /> Saving...</Fragment>;
    }

    let shoppingCartButton = <button type="button" className="continue ml-4" onClick={continueHandler.bind(this, 1)} disabled={props.addingToCart}>{buttonLabel}</button>;
    if (props.action === 'edit') {
        shoppingCartButton = null;
    }

    const renderFiles = () => {
        if (props.variables.uth_unisex_files.length === 0) {
            return <div>No files selected</div>;
        }

        return (
            <ul>
                {props.variables.uth_unisex_files.map((file, index) => {
                    return (
                        <li>
                            {file.name}
                            <Tooltip title="Remove File" position="bottom" arrow size="small" className="action-tooltip">
                                <i className="fas fa-trash" onClick={props.removeFile.bind(this, index)} />
                            </Tooltip>
                        </li>
                    );
                })}
            </ul>
        );
    };

    let uploadingFiles = null;
    if ((props.addingToCart || props.savingWork) && props.variables.uth_unisex_files.length > 0) {
        uploadingFiles = <div><i className="fas fa-circle-notch fa-spin" /> Your files are uploading. It may take a few seconds depending on the size of the file.</div>;
    }

    return (
        <div className="form-container uth-unisex-form-container">
            <h5>Make your selection</h5>
            <div className="title">Custom Tee Shirt screen print request:</div>
            <div className="unisex-form">
                <div className="image-position">
                    <div className="mb-2"><b>Image Position:</b></div>
                    <div className="position-option">
                        <input type="checkbox" checked={props.variables.uth_unisex_position_full_front} onChange={handleSetField.bind(this, 'uth_unisex_position_full_front')} />
                        Full Front (image size: 12" w x 16" h)
                    </div>
                    <div className="position-option">
                        <input type="checkbox" checked={props.variables.uth_unisex_position_full_back} onChange={handleSetField.bind(this, 'uth_unisex_position_full_back')} />
                        Full Back (image size: 12" w x 16" h)
                    </div>
                    <div className="position-option">
                        <input type="checkbox" checked={props.variables.uth_unisex_position_left_chest} onChange={handleSetField.bind(this, 'uth_unisex_position_left_chest')} />
                        Left Chest (image size: 4" w x 2" h)
                    </div>
                    <div className="position-option">
                        <input type="checkbox" checked={props.variables.uth_unisex_position_right_chest} onChange={handleSetField.bind(this, 'uth_unisex_position_right_chest')} />
                        Right Chest (image size: 4" w x 2" h)
                    </div>
                    <div className="position-option">
                        <input type="checkbox" checked={props.variables.uth_unisex_position_sleeve} onChange={handleSetField.bind(this, 'uth_unisex_position_sleeve')} />
                        Sleeve (image size: 2" w x 1" h)
                    </div>
                    <div className="position-option">
                        <input type="checkbox" checked={props.variables.uth_unisex_position_other} onChange={handleSetField.bind(this, 'uth_unisex_position_other')} />
                        Other area:
                        <input type="text" value={props.variables.uth_unisex_position_other_text} onChange={handleSetField.bind(this, 'uth_unisex_position_other_text')} />
                    </div>
                </div>
                <div className="ink">
                    <div className="ink-section">
                        <div className="options">
                            <div className="title"><b>Ink:</b></div>
                            <div className="option">
                                <input type="checkbox" checked={props.variables.uth_unisex_ink_university_orange} onChange={handleSetField.bind(this, 'uth_unisex_ink_university_orange')} />
                                University Orange
                            </div>
                            <div className="option">
                                <input type="checkbox" checked={props.variables.uth_unisex_ink_university_blue} onChange={handleSetField.bind(this, 'uth_unisex_ink_university_blue')} />
                                University Blue
                            </div>
                            <div className="option">
                                <input type="checkbox" checked={props.variables.uth_unisex_ink_university_grey} onChange={handleSetField.bind(this, 'uth_unisex_ink_university_grey')} />
                                University Gray
                            </div>
                            <div className="option">
                                <input type="checkbox" checked={props.variables.uth_unisex_ink_university_black_white} onChange={handleSetField.bind(this, 'uth_unisex_ink_university_black_white')} />
                                Black &amp; White
                            </div>
                        </div>
                        <div className="colors">
                            <div className="title">Traditional UTHealth Houston Colors:</div>
                            <div className="color">
                                <div className="circle university-orange">PMS 167U</div>
                                <div className="name">University Orange</div>
                            </div>
                            <div className="color">
                                <div className="circle university-blue">PMS 5405U</div>
                                <div className="name">University Blue</div>
                            </div>
                            <div className="color">
                                <div className="circle university-grey">Cool Gray 11U</div>
                                <div className="name">University Gray</div>
                            </div>
                            <div className="color">
                                <div className="circle black-white">
                                    <img src="https://ac-ut-health.s3.amazonaws.com/black-white-circle.png" alt="Black White" />
                                </div>
                                <div className="name">Black &amp; White</div>
                            </div>
                        </div>
                    </div>
                    <div className="ink-section">
                        <div className="options">
                            <div className="title"><b>Ink:</b></div>
                            <div className="option">
                                <input type="checkbox" checked={props.variables.uth_unisex_ink_gulf_blue} onChange={handleSetField.bind(this, 'uth_unisex_ink_gulf_blue')} />
                                Gulf Blue
                            </div>
                            <div className="option">
                                <input type="checkbox" checked={props.variables.uth_unisex_ink_mustard} onChange={handleSetField.bind(this, 'uth_unisex_ink_mustard')} />
                                Mustard
                            </div>
                            <div className="option">
                                <input type="checkbox" checked={props.variables.uth_unisex_ink_dark_sage} onChange={handleSetField.bind(this, 'uth_unisex_ink_dark_sage')} />
                                Dark Sage
                            </div>
                            <div className="option">
                                <input type="checkbox" checked={props.variables.uth_unisex_ink_dusty_lavender} onChange={handleSetField.bind(this, 'uth_unisex_ink_dusty_lavender')} />
                                Dusty Lavender
                            </div>
                        </div>
                        <div className="colors">
                            <div className="title">Secondary Colors:</div>
                            <div className="color">
                                <div className="circle gulf-blue">PMS 295U</div>
                                <div className="name">Gulf Blue</div>
                            </div>
                            <div className="color">
                                <div className="circle mustard">PMS 7406U</div>
                                <div className="name">Mustard</div>
                            </div>
                            <div className="color">
                                <div className="circle dark-sage">PMS 555U</div>
                                <div className="name">Dark Sage</div>
                            </div>
                            <div className="color">
                                <div className="circle dusty-lavender">PMS 668U</div>
                                <div className="name">Dusty Lavender</div>
                            </div>
                        </div>
                    </div>
                    <div className="message">You can choose up to 4 different PMS colors.</div>
                </div>
                <div className="size-shirt-color-container">
                    <div className="shirt-color">
                        <div className="label mb-2">Shirt Color:</div>
                        <select value={props.variables.uth_unisex_shirt_color} onChange={handleSetField.bind(this, 'uth_unisex_shirt_color')}>
                            <option value="">Select Color</option>
                            <option value="1">White 100% cotton</option>
                            <option value="2">Black 100% cotton</option>
                            <option value="3">Navy 100% cotton</option>
                            <option value="4">Texas Orange 100% cotton</option>
                        </select>
                    </div>
                    <div className="sizes">
                        <div className="mb-2"><b>Sizes | Quantity | Measurements:</b> <span className="minimum-order">(Minimum Order 15 <span className="required">*</span>)</span></div>
                        <div className="size-option">
                            <input type="checkbox" checked={props.variables.uth_unisex_size_small} onChange={handleSetField.bind(this, 'uth_unisex_size_small')} />
                            <div className="label">Small</div>
                            <input type="number" value={props.variables.uth_unisex_size_small_qty} onChange={handleSetField.bind(this, 'uth_unisex_size_small_qty')} />
                            <div className="measurements">Chest Width 18" | Body Length 28" | Sleeve Length 16-1/2"</div>
                        </div>
                        <div className="size-option">
                            <input type="checkbox" checked={props.variables.uth_unisex_size_medium} onChange={handleSetField.bind(this, 'uth_unisex_size_medium')} />
                            <div className="label">Medium</div>
                            <input type="number" value={props.variables.uth_unisex_size_medium_qty} onChange={handleSetField.bind(this, 'uth_unisex_size_medium_qty')} />
                            <div className="measurements">Chest Width 20" | Body Length 29" | Sleeve Length 18"</div>
                        </div>
                        <div className="size-option">
                            <input type="checkbox" checked={props.variables.uth_unisex_size_large} onChange={handleSetField.bind(this, 'uth_unisex_size_large')} />
                            <div className="label">Large</div>
                            <input type="number" value={props.variables.uth_unisex_size_large_qty} onChange={handleSetField.bind(this, 'uth_unisex_size_large_qty')} />
                            <div className="measurements">Chest Width 22" | Body Length 30" | Sleeve Length 19-1/2"</div>
                        </div>
                        <div className="size-option">
                            <input type="checkbox" checked={props.variables.uth_unisex_size_xl} onChange={handleSetField.bind(this, 'uth_unisex_size_xl')} />
                            <div className="label">X-Large</div>
                            <input type="number" value={props.variables.uth_unisex_size_xl_qty} onChange={handleSetField.bind(this, 'uth_unisex_size_xl_qty')} />
                            <div className="measurements">Chest Width 24" | Body Length 31" | Sleeve Length 21"</div>
                        </div>
                        <div className="size-option">
                            <input type="checkbox" checked={props.variables.uth_unisex_size_2xl} onChange={handleSetField.bind(this, 'uth_unisex_size_2xl')} />
                            <div className="label">2XL</div>
                            <input type="number" value={props.variables.uth_unisex_size_2xl_qty} onChange={handleSetField.bind(this, 'uth_unisex_size_2xl_qty')} />
                            <div className="measurements">Chest Width 26" | Body Length 32" | Sleeve Length 22-1/2"</div>
                        </div>
                        <div className="size-option">
                            <input type="checkbox" checked={props.variables.uth_unisex_size_3xl} onChange={handleSetField.bind(this, 'uth_unisex_size_3xl')} />
                            <div className="label">3XL</div>
                            <input type="number" value={props.variables.uth_unisex_size_3xl_qty} onChange={handleSetField.bind(this, 'uth_unisex_size_3xl_qty')} />
                            <div className="measurements">Chest Width 28" | Body Length 33" | Sleeve Length 24"</div>
                        </div>
                    </div>
                </div>
                <div className="measurements-tips">
                    <div className="mb-2"><b>Measurement Tips:</b></div>
                    <div>Chest width: Measured across the chest 1" below arm-hole when laid flat.</div>
                    <div>Body length at back: Measured from highpoint shoulder to finished hem at back.</div>
                    <div>Sleeve Length: Start at center of neck and measure down the shoulder down to the sleeve to hem.</div>
                </div>
                <div className="artworks">
                    <div className="title">If you have artwork please upload it here:</div>
                    <div {...getRootProps({ className: 'dropzone-container' })}>
                        <input {...getInputProps()} />
                        <button>Browse</button>
                    </div>
                    {renderFiles()}
                    {uploadingFiles}
                </div>
            </div>
            <div className="text-center">
                <button type="button" className="continue" onClick={continueHandler.bind(this, 2)} disabled={props.savingWork}>{saveWorkLabel}</button>
                {shoppingCartButton}
            </div>
            <div className="text-center mt-3">Please contact Help Desk for custom quote.</div>
            <div className="text-center">
                <button className="help-desk-button" onClick={props.showHelpModal}>Help Desk</button>
            </div>
        </div>
    );
});

export default UthApparelUnisexForm;
